import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuardService } from '../../shared/libs/auth/authorization-guard.service';
import { CompanyComponent } from './components/company.component';
import { CompanyOrderListComponent } from './components/company-order-list/company-order-list.component';
import { CompanyStyleDetailComponent } from './components/company-style-detail/company-style-detail.component';
import { CompanyStyleListComponent } from './components/company-style-list/company-style-list.component';
import { CompanyOrderDetailComponent } from './components/company-order-detail/company-order-detail.component';
import { CompanyOrderDetailInfoComponent } from './components/company-order-detail/company-order-detail-info/company-order-detail-info.component';
import { CompanyOrderDetailShotsComponent } from './components/company-order-detail/company-order-detail-shots/company-order-detail-shots.component';
import { CompanyTemplateListComponent } from './components/company-template-list/company-template-list.component';
import { CompanyTemplateDetailComponent } from './components/company-template-detail/company-template-detail.component';
import { CompanyPhotographerListComponent } from './components/company-photographer-list/company-photographer-list.component';
import { Roles } from 'src/app/shared/types/role.enum';

const routes: Routes = [
	{
		path: '',
		component: CompanyComponent,
		children: [
			{
				path: '',
				redirectTo: 'order-list',
				pathMatch: 'full'
			},
			{
				path: 'order-list',
				component: CompanyOrderListComponent,
				data: { roles: [Roles.ORDER_LIST] },
				canActivate: [AuthorizationGuardService]
			},

			{
				path: 'order-info/order-detail-info/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-info',
				pathMatch: 'full',
				data: { roles: [Roles.ORDER_DETAILS] },
			},
			{
				path: 'order-info/order-detail-shots/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-shots',
				pathMatch: 'full',
				data: { roles: [Roles.ORDER_DETAILS] },
			},

			{
				path: 'order-view',
				redirectTo: 'order-view/new',
				pathMatch: 'full',
				data: { roles: [Roles.ORDER_CREATE] },
			},
			{
				path: 'order-view/:orderId',
				component: CompanyOrderDetailComponent,
				data: {
					roles: [Roles.ORDER_DETAILS]
				},
				canActivate: [AuthorizationGuardService],
				children: [
					{
						path: '',
						redirectTo: 'order-detail-info',
						pathMatch: 'full'
					},
					{
						path: 'order-detail-info',
						component: CompanyOrderDetailInfoComponent
					},
					{
						path: 'order-detail-shots',
						component: CompanyOrderDetailShotsComponent
					}
				]
			},

			{
				path: 'style-list',
				component: CompanyStyleListComponent,
				data: { roles: [Roles.STYLE_LIST] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'style-info/:modelId',
				component: CompanyStyleDetailComponent,
				data: { roles: [Roles.STYLE_DETAILS] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'photographer-list',
				component: CompanyPhotographerListComponent,
				data: { roles: [Roles.PHOTOGRAPHER_LIST] },
				canActivate: [AuthorizationGuardService]
			},
			/*{
				path: 'edit-photographer/:photographerId',
				component: CompanyPhotographerDetailComponent,
				data: { title: 'Edit Photographers | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_EDIT] },
				canActivate: [AuthorizationGuardService]
			},*/

			{
				path: 'template-list',
				component: CompanyTemplateListComponent,
				data: { roles: [Roles.TEMPLATE_LIST] },
				canActivate: [AuthorizationGuardService]
			},

			{
				path: 'template-detail/:templateId',
				component: CompanyTemplateDetailComponent,
				data: { roles: [Roles.TEMPLATE_CREATE] },
				canActivate: [AuthorizationGuardService]
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class CompanyRouting {}
